import { TERMINAL_DEFAULT_VALUE } from "components/filters/ToggleTerminalsFilter";
import { AppList } from "components/list/AppList";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import React from "react";

import { stylesForColorInheritInList } from "../../../components/_helpers/useStyles";
import { NeedOfWorkforceFilter } from "./ListFilters";
import { ToggleDatesLaborForecastEnum } from "./ToggleDatesFilter";
import { WorkforceGrid } from "./WorkforceGrid";

const defaultFilters = {
	"eta_date|etd_date": [ToggleDatesLaborForecastEnum.TODAY],
	terminal_id: [TERMINAL_DEFAULT_VALUE],
};

export const NeedOfWorkforceList = ({ permissions, ...props }) => {
	const classes = stylesForColorInheritInList();
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();
	const permanentFilters = { ...globalFilters };
	const defaultFilterValues = { ...defaultFilters, ...globalFilters };

	return (
		<AppList
			{...props}
			exporter={false}
			bulkActionButtons={false}
			filters={<NeedOfWorkforceFilter {...props} />}
			actions={null}
			classes={classes}
			pagination={false}
			filter={permanentFilters}
			filterDefaultValues={defaultFilterValues}
		>
			<WorkforceGrid permissions={permissions} {...props} />
		</AppList>
	);
};
